<div style="
z-index: 1056;
position: fixed;
bottom: -0.5rem;
left:0;
display: flex; 
overflow-x: scroll;
max-width: 100vw;
"> 
    <div style="background-color: var(--vz-footer-bg)" *ngFor="let tab of openTabs; index as i;">
        <div class="bg-soft-info px-3 py-2 rounded" style="display: flex; justify-content: center;">
            <div style="display: flex; align-items: center;"> {{tab.name}}</div>
            <button (click)="openTab(tab.elementId)" class="ri-picture-in-picture-exit-line" style="
                color: var(--vz-body-color);
                background-color: transparent;
                border: 0;
                font-size: 1rem;
                transform: rotate(-270deg) !important;
                border-radius: 0.25rem;
                opacity: 0.5;"> 
            </button>
        </div>
    </div>

</div>